// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2x9TE","content":"LoadingAlert_content__3aef1"};